import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "../types/loadedData";

interface UserState {
  user: UserType | null;
  token: string | null;
  agents: UserType[];
  staffs: UserType[];
  staff: UserType | null;
  customers: UserType[];
  customer: UserType | null;
  userLoaded: boolean;
}

const initialState: UserState = {
  token: "",
  user: null,
  agents: [],
  staffs: [],
  staff: null,
  customers: [],
  customer: null,
  userLoaded: false,
};

export const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserType | null>) => {
      state.user = action.payload;
    },
    setUserLoaded: (state, action: PayloadAction<boolean>) => {
      state.userLoaded = action.payload;
    },
    setToken: (state, action: PayloadAction<string | null>) => {
      state.token = action.payload;
    },
    setAgents: (state, action: PayloadAction<UserType[]>) => {
      state.agents = action.payload;
    },
    setStaffs: (state, action: PayloadAction<UserType[]>) => {
      state.staffs = action.payload;
    },
    setStaff: (state, action: PayloadAction<UserType>) => {
      state.staff = action.payload;
    },
    setCustomers: (state, action: PayloadAction<UserType[]>) => {
      state.customers = action.payload;
    },
    setCustomer: (state, action: PayloadAction<UserType>) => {
      state.customer = action.payload;
    },
  },
});

export const {
  setToken,
  setUser,
  setAgents,
  setUserLoaded,
  setStaff,
  setStaffs,
  setCustomers,
  setCustomer,
} = user.actions;

export default user.reducer;
